<template>
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 justify-start py-4">
        <AlertCard v-if="active !== EAlertState.PENDENTE"
                   :vediLink="{name:'RichiamaEntro'}"
                   class="h-24"
                   titolo="Stato ok"
                   :numero="ok"
                   colore-stato-class="text-next-atp md:text-xl text-lg translate-y-1/5"></AlertCard>
        <AlertCard v-if="active !== EAlertState.SCADUTO"
                   :vediLink="{name:'AlertScaduti'}"
                   class="h-24" titolo="Alert scaduti"
                   :numero="scaduti"
                   colore-stato-class="text-next-orange md:text-xl text-lg translate-y-1/5"></AlertCard>
        <AlertCard v-if="active !== EAlertState.IN_SCADENZA"
                   :vediLink="{name:'AlertScadenza'}"
                   class="h-24" titolo="Alert in scadenza"
                   :numero="in_scadenza"
                   colore-stato-class="text-next-pre md:text-xl text-lg translate-y-1/5"></AlertCard>
        <AlertCard :vediLink="{name:'ListaClienti'}"
                   class="h-24"
                   titolo="Clienti / Contatti"
                   :numero="`${clienti}/${contatti}`"
                   colore-stato-class="text-next-bri md:text-xl text-lg translate-y-1/5"></AlertCard>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import AlertCard from "@/components/AlertCard.vue";
import {AlertState} from "@/types";

@Options({
    name:'HomeAlertBar',
    components:{
        AlertCard
    },
    props: {
        ok: [Number, String],
        scaduti: [Number, String],
        in_scadenza: [Number, String],
        clienti: [Number, String],
        contatti: [Number, String],
        active: Number
    }
})
export default class HomeAlertBar extends Vue {
    EAlertState= AlertState

    ok!: string|number
    scaduti!: string|number
    in_scadenza!: string|number
    clienti!: string|number
    contatti!: string|number
    active!: number
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
